import { render, staticRenderFns } from "./album-list-results.vue?vue&type=template&id=12ce2116"
import script from "./album-list-results.vue?vue&type=script&lang=js"
export * from "./album-list-results.vue?vue&type=script&lang=js"
import style0 from "./album-list-results.vue?vue&type=style&index=0&id=12ce2116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports